<template>
	<transition	name='fade'
		@before-enter='bodyScrollRemove'
		@after-leave='bodyScrollAdd'
	>
		<div class='Alert popup popup--center' v-if='show'>
			<section class='popup__main content__section' v-click-outside='hideAlertHandle'>
				<header class='popup__header'>
					<div class='headline headline--l1' v-html='message'></div>
					<div class='content' v-html='content'></div>
					<footer class='popup__footer'>
						<button class='btn waves-effect waves-light' @click='onOkHandle'>Ok</button>
					</footer>
				</header>
			</section>
		</div>
	</transition>
</template>

<script>
import EventBus from '__jsEbentBus';
import ClickOutside from 'vue-click-outside';
export default {
	name:  'Alert',
	data() {
		return {
			show:     false,
			message:  '',
			content:  '',
			onOk:     () => {},
			onCancel: () => {},
		};
	},
	methods: {
		...mapMutations('createUpdateDeal', ['bodyScrollAdd', 'bodyScrollRemove']),
		hideAlertHandle() {
			if (this.show) {
				this.show = false;
			}
		},
		onCancelHandle() {
			this.show = false;
			this.onCancel();
		},
		onOkHandle() {
			this.show = false;
			this.onOk();
		},
	},
	mounted() {
		EventBus.$on('alert', (options) => {
			setTimeout(() => {
				this.message = (options.message) ? (options.message) : ('');
				this.content = (options.content) ? (options.content) : ('');
				if (typeof options.onOk === 'function') {
					this.onOk = options.onOk;
				}
				else {
					this.onOk = () => {};
				}
				if (typeof options.onCancel === 'function') {
					this.onCancel = options.onCancel;
				}
				else {
					this.onCancel = () => {};
				}
				this.show = true;
			}, 0);
		});
	},
	directives: {
		ClickOutside
	},
};
</script>
